import { fetchNotificationDetails } from "../../services/notificationService";
import { NOTIFY_COUNT } from "./ActionType";
import type { Dispatch } from "redux";

interface NotifyCountAction {
  type: typeof NOTIFY_COUNT;
  payload: number;
}

// G-NOTIF-01: bell badge count off the enterprise /api/v1/notifications via the
// notificationService adapter (legacy envelope preserved: messageCount[0].totalCount = unread).
export function getNotificationDetails() {
  return (dispatch: Dispatch<NotifyCountAction>) => {
    fetchNotificationDetails()
      .then((data) => {
        if (data.status === "Success") {
          dispatch({
            type: NOTIFY_COUNT,
            payload: data.messageCount[0].totalCount,
          });
        }
      })
      .catch(() => {
        // Swallow — the badge just stays at its previous value.
      });
  };
}
